<template>
  <div
    class="fixed bottom-0 left-0 right-0 flex flex-row flex-wrap justify-between w-full px-4 py-2 bg-gray-1000"
  >
    <div class="flex justify-between w-full" :class="{'mb-2': isOpen}">
      <div class="flex flex-col justify-center">
        <h2
          class="hidden m-0 antialiased font-semibold text-white ds-text-xl md:inline-block"
          v-if="!isOpen"
        >
          Get Started today with your free athlete profile!
          <i class="sr-2 sr-v2-arrow-right" />
        </h2>
        <p class="m-0 antialiased font-semibold text-white ds-text-xl" v-else>
          <span class="hidden md:inline">Take control of your recruiting process.&nbsp;</span>Sign up below to create your free
          {{ $domain.config('title_name') }} profile.
        </p>
      </div>
      <Button
        data-qa="get_started_now_button"
        text="Get Started Now"
        emphasis="high"
        color="teal"
        class="w-full md:w-auto"
        @click="open"
        v-if="!isOpen"
      />
      <Button
        emphasis="high"
        color="gray"
        class="bg-gray-800 hover:bg-gray-400"
        icon="sr-2 sr-v2-x"
        @click="close"
        v-else
      />
    </div>

    <form
      method="GET"
      action="/signup"
      class="flex flex-wrap w-full otg-signup-form"
      v-if="isOpen"
    >
      <div
        class="flex flex-grow w-full sign-up-form-fields_fieldWrap user-type-selection lg:w-auto lg:pr-3"
      >
        <div class="w-full mt-2 mb-4 text-center lg:mb-0 lg:mt-0 flex flex-row">
          <input type="hidden" name="site_id" :value="selectedSportOption ? selectedSportOption.sportId : null" />
          <input type="hidden" name="gender" :value="selectedSportOption ? selectedSportOption.gender : null" />
          <input
            type="radio"
            class="hidden stv-radio-button"
            name="email_type"
            value="player"
            id="player_button"
            required
          />
          <label
            data-qa="athlete_btn"
            for="player_button"
            class="w-1/2 p-3 antialiased font-semibold text-white border-2 border-teal-300 border-solid rounded-l-lg ds-text-base"
          >I'm an Athlete</label>
          <input
            type="radio"
            class="hidden stv-radio-button"
            name="email_type"
            value="parent"
            id="parent_button"
            required
          />
          <label
            data-qa="parent_op"
            for="parent_button"
            class="w-1/2 p-3 antialiased font-semibold text-white border-2 border-teal-300 border-solid rounded-r-lg ds-text-base"
          >I'm a Parent</label>
        </div>
      </div>

      <div
        class="w-full mb-4 lg:flex lg:flex-grow md:pr-3 sign-up-form-fields_fieldWrap md:w-1/2 lg:w-auto md:mb-0"
      >
        <label for="email" style="display: block; width: 0; height:0; overflow: hidden;">Email</label>
        <input
          data-qa="type_email"
          type="email"
          name="email"
          placeholder="My Email..."
          value
          required
          autocomplete="off"
          class="w-full p-3 text-white placeholder-white bg-teal-500 border-2 border-teal-300 border-solid rounded-lg ds-text-base focus:outline-none"
        />
      </div>
      <div
        class="flex flex-grow w-full mb-4 lg:pr-3 sign-up-form-fields_fieldWrap md:w-1/2 lg:w-auto lg:mb-0"
      >
        <select
          required
          data-qa="athlete_sport_option"
          id="signup-form-site-id"
          class="w-full p-3 text-white bg-teal-500 border-2 border-teal-300 rounded-lg ds-text-base focus:outline-none"
          @change="selectSportOption($event.target.value)"
        >
          <option disabled selected value class="p-3" v-if="!domainSportAndGender">Athlete's Sport</option>
          <option
            v-for="(option, index) in options"
            :selected="selectedSportOption && selectedSportOption.sportId === option.sportId && selectedSportOption.gender === option.gender ? true : false"
            :key="index"
            :value="index"
          >{{option.name}}</option>
        </select>
      </div>

      <div class="w-full text-right sign-up-form-fields_fieldWrap cta-signup-submit lg:w-auto">
        <input
          data-qa="create_profile_btn"
          type="submit"
          class="w-full p-3 font-medium text-white bg-teal-300 border-2 border-teal-300 border-solid rounded-md ds-text-base"
          value="Create My Free Profile"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { Button } from '@sportsrecruits/playbook';
import api from "@/services/api";
export default {
  components: {
    Button,
  },
  data() {
    return {
      isOpen: false,

      sportOptions: sportOptions,
      selectedSportOption: null,
    };
  },
  computed: {
    selectedSport() {
      return this.selectedSportOption
        ? JSON.stringify({
            site_id: this.selectedSportOption.sportId.toString(),
            gender: this.selectedSportOption.gender.toString(),
          })
        : null;
    },
    options() {
      if (this.domainSportAndGender) {
        return [this.domainSportAndGender];
      }
      
      return sportOptions;
    },
    domainSportAndGender() {
      if (api.clientData().domain.site_id !== null) {
        return sportOptions[sportOptions.findIndex(option => {
          return option.sportId == api.clientData().domain.site_id && option.gender == api.clientData().domain.gender;
        })];
      }
    },
  },
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    selectSportOption(index) {
      this.selectedSportOption = this.options[index];
    },
  },
  mounted() {
    if (this.domainSportAndGender) {
      this.selectedSportOption = this.domainSportAndGender;
    }
  }
};

const sportOptions = [
  { sportId: 6, gender: 1, name: "Men's Baseball" },
  { sportId: 8, gender: 1, name: "Men's Basketball" },
  { sportId: 8, gender: 2, name: "Women's Basketball" },
  { sportId: 18, gender: 2, name: "Women's Beach Volleyball" },
  { sportId: 23, gender: 1, name: "Men's Cross Country" },
  { sportId: 23, gender: 2, name: "Women's Cross Country" },
  { sportId: 3, gender: 2, name: "Women's Field Hockey" },
  { sportId: 17, gender: 1, name: "Men's Football" },
  { sportId: 20, gender: 1, name: "Men's Golf" },
  { sportId: 20, gender: 2, name: "Women's Golf" },
  { sportId: 11, gender: 1, name: "Men's Gymnastics" },
  { sportId: 11, gender: 2, name: "Women's Gymnastics" },
  { sportId: 9, gender: 1, name: "Men's Ice Hockey" },
  { sportId: 9, gender: 2, name: "Women's Ice Hockey" },
  { sportId: 1, gender: 1, name: "Men's Lacrosse" },
  { sportId: 1, gender: 2, name: "Women's Lacrosse" },
  { sportId: 10, gender: 1, name: "Men's Rowing" },
  { sportId: 10, gender: 2, name: "Women's Rowing" },
  { sportId: 21, gender: 1, name: "Men's Skiing" },
  { sportId: 21, gender: 2, name: "Women's Skiing" },
  { sportId: 4, gender: 1, name: "Men's Soccer" },
  { sportId: 4, gender: 2, name: "Women's Soccer" },
  { sportId: 5, gender: 2, name: "Women's Softball" },
  { sportId: 16, gender: 1, name: "Men's Squash" },
  { sportId: 16, gender: 2, name: "Women's Squash" },
  { sportId: 7, gender: 1, name: "Men's Swimming And Diving" },
  { sportId: 7, gender: 2, name: "Women's Swimming And Diving" },
  { sportId: 15, gender: 1, name: "Men's Tennis" },
  { sportId: 15, gender: 2, name: "Women's Tennis" },
  { sportId: 22, gender: 1, name: "Men's Track And Field" },
  { sportId: 22, gender: 2, name: "Women's Track And Field" },
  { sportId: 2, gender: 1, name: "Men's Volleyball" },
  { sportId: 2, gender: 2, name: "Women's Volleyball" },
  { sportId: 12, gender: 1, name: "Men's Water Polo" },
  { sportId: 12, gender: 2, name: "Women's Water Polo" },
  { sportId: 13, gender: 1, name: "Men's Wrestling" },
];
</script>

<style lang="scss" scoped>
select,
input {
  min-width: 200px;
  width: 100%;
}

select {
  appearance: none;
  background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='15' height='15' x…1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='white'/></g></svg>")
    right 5px center no-repeat;
  background-color: inherit;
}

.stv-radio-button:checked + label {
  background-color: #2dcdbd !important;
}
</style>
